import * as Sentry from "@sentry/vue";

interface ErrorDetails {
    message: string;
    componentName?: string;
    info?: string;
    stack?: string;
    context?: Record<string, any>;
    userMessage?: string; // Add this field for user-friendly messages
}

export interface ErrorTracker {
  captureError(error: Error | ErrorDetails, context?: Record<string, any>): string;
  captureMessage(message: string, context?: Record<string, any>): void;
}

class ErrorTrackingService {
  private static instance: ErrorTrackingService;

  private constructor() {}

  static getInstance(): ErrorTrackingService {
    if (!ErrorTrackingService.instance) {
      ErrorTrackingService.instance = new ErrorTrackingService();
    }
    return ErrorTrackingService.instance;
  }

  captureError(error: Error | ErrorDetails, context?: Record<string, any>): string {
    const userMessage = 'An unexpected error occurred. Our team has been notified.';
    
    if (error instanceof Error) {
      Sentry.captureException(error, {
        extra: context
      });
    } else {
      Sentry.captureMessage(error.message, {
        extra: {
          ...error,
          ...context
        }
      });
    }

    // Log to console in development
    if (import.meta.env.DEV) {
      console.error('Error captured:', error, context);
    }

    return error instanceof Error ? userMessage : (error.userMessage || userMessage);
  }

  captureMessage(message: string, context?: Record<string, any>) {
    Sentry.captureMessage(message, {
      extra: context
    });

    if (import.meta.env.DEV) {
      // console.log('Message captured:', message, context);
    }
  }
}

export const errorTracker: ErrorTracker = ErrorTrackingService.getInstance();
